export const POOLS_WITH_EMISSIONS = [
  {
    address: '0x3a2976b76b9af12639878b87b4ccef2e951ca5aa', // wRose/USDC
    emission: 1500000
  },
  {
    address: '0x6cdcf811073b358031239e3792aefcdd875498b0', // wRose/Neby
    emission: 2500000
  },
  {
    address: '0xeafb04b5d4fb753c32dbb2ec32b3bf7cdc7f5144', // wRose/wETH
    emission: 1500000
  },
  // {
  //   address: '0xee91352a9aba9ae2ce677545ef138a9759e50629', // wRose/USDT
  //   emission: 1500000
  // }
];
